import { render, staticRenderFns } from "./PersonalInvoiceManagement.vue?vue&type=template&id=83323608&scoped=true"
import script from "./PersonalInvoiceManagement.vue?vue&type=script&lang=js"
export * from "./PersonalInvoiceManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83323608",
  null
  
)

export default component.exports